import { render, staticRenderFns } from "./serbestfatura.vue?vue&type=template&id=757217e3&scoped=true&"
import script from "./serbestfatura.vue?vue&type=script&lang=js&"
export * from "./serbestfatura.vue?vue&type=script&lang=js&"
import style0 from "./serbestfatura.vue?vue&type=style&index=0&id=757217e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757217e3",
  null
  
)

export default component.exports